import { render, staticRenderFns } from "./ProposalHeader.vue?vue&type=template&id=13c76030"
import script from "./ProposalHeader.vue?vue&type=script&lang=js"
export * from "./ProposalHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports